import { createIcon, Svg } from "@gluestack-ui/icon";
import { Path } from "react-native-svg";

const FlagIcon = createIcon({
  Root: Svg,
  viewBox: "0 0 20 20",
  path: (
    <>
      <Path
        d="M11.7595 5.6005H16.7839C17.1566 5.6005 17.343 5.6005 17.452 5.67887C17.5471 5.74725 17.609 5.8525 17.6226 5.96883C17.6382 6.10217 17.5477 6.26509 17.3667 6.59093L16.142 8.79526C16.0764 8.91343 16.0436 8.97251 16.0307 9.03508C16.0193 9.09046 16.0193 9.14758 16.0307 9.20296C16.0436 9.26553 16.0764 9.32462 16.142 9.44279L17.3667 11.6471C17.5477 11.9729 17.6382 12.1359 17.6226 12.2692C17.609 12.3855 17.5471 12.4908 17.452 12.5592C17.343 12.6375 17.1566 12.6375 16.7839 12.6375H10.4539C9.98723 12.6375 9.75387 12.6375 9.57561 12.5467C9.41881 12.4668 9.29133 12.3393 9.21143 12.1825C9.12061 12.0043 9.1206 11.7709 9.1206 11.3042V9.11902M6.04191 17.9155L2.52339 3.84147M3.84287 9.11907H10.4262C10.8929 9.11907 11.1262 9.11907 11.3045 9.02824C11.4613 8.94835 11.5888 8.82086 11.6687 8.66406C11.7595 8.4858 11.7595 8.25245 11.7595 7.78574V3.41536C11.7595 2.94865 11.7595 2.7153 11.6687 2.53704C11.5888 2.38024 11.4613 2.25275 11.3045 2.17286C11.1262 2.08203 10.8929 2.08203 10.4262 2.08203H3.79126C3.20916 2.08203 2.91811 2.08203 2.71904 2.20264C2.54457 2.30836 2.41493 2.47439 2.35469 2.6693C2.28596 2.89168 2.35656 3.17404 2.49774 3.73876L3.84287 9.11907Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </>
  ),
});

FlagIcon.displayName = "FlagIcon";
export { FlagIcon };
